import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * CustomFieldsApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/customFieldsApi/customFieldsApi.service.js.
 *
 * Legacy `.forms` sub-namespace dropped: its `service` URL was never
 * initialised by the legacy `init()` (only the top-level `service` was set),
 * so every `forms.*` call would have hit an empty-string URL. No consumers
 * referenced `customFields.forms.*` — verified by grep.
 *
 * Endpoint /v2 for `list` and `update`, /v1 for `create` (preserved from legacy).
 */
const CUSTOM_FIELDS_BASE_V1 = "/v1/api/tenant/settings/custom/fields";
const CUSTOM_FIELDS_BASE_V2 = "/v2/api/tenant/settings/custom/fields";

@Injectable({ providedIn: "root" })
export class CustomFieldsApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(CUSTOM_FIELDS_BASE_V2, {
        params: buildParams(props, PAGINATION_SEARCH_FIELDS),
      }),
    );
  }

  create(props: unknown): Promise<AjsResponse<unknown>> {
    return wrapAjs(this.http.post<unknown>(CUSTOM_FIELDS_BASE_V1, props));
  }

  update(props: { ndx: number | string }): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.put<unknown>(`${CUSTOM_FIELDS_BASE_V2}/${props.ndx}`, props),
    );
  }
}
